import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GraphicService } from '../shared/graphic.service';
import { NgStyle, NgIf, NgClass } from '@angular/common';

@Component({
    selector: 'box-title',
    templateUrl: './box-title.component.html',
    styleUrls: ['./box-title.component.css'],
    standalone: true,
    imports: [NgStyle, NgIf, NgClass]
})
export class BoxTitleComponent implements OnInit {

  @Input() titulo: string;
  @Input() mensagem: string;
  @Input() horario: string;
  @Input() color: string;
  @Input() textColor: string = '#101316';
  @Input() mostraAviso = false;
  @Input() btnConfiguracao = false;
  @Input() btnClose = false;
  @Input() shadow = false;
  @Output() minimizeMobile = new EventEmitter<void>();

  classClosed: boolean = false;
  classOcultar: boolean = false;
  iconRotated = false;
  constructor(private graphicService: GraphicService) { }

  ngOnInit() {
  }

  abrirFecharBox() {
    this.classClosed = !this.classClosed;
    this.classOcultar = !this.classOcultar;
    this.iconRotated = !this.iconRotated;

  }

  alteraMostraConfRoteiro(){
    this.graphicService.mostraConfiguracaoRoteiro = !this.graphicService.mostraConfiguracaoRoteiro;
  }

  minimizarBoxMobile() {
    this.minimizeMobile.emit();
  }
}
